import React from "react";
import {
  FlucsDownIcon as ArrowDown,
  FlucsUpIcon as ArrowUp,
  Odds,
} from "@picklebet/ui";
import { BetOddsChange } from "./BetOddsChange";
import {
  type OddsFormatPreferences,
  usePreferences,
} from "@/hooks/firestore/user/usePreferences";

import * as styles from "./OddsWithChanges.module.scss";

type OddsWithChangesProps = {
  odds: number;
  initialOdds?: number;
  animationLength?: number | null;
  prefix?: string;
  isSP?: boolean;
  children?: React.ReactNode;
};

const OddsWithChanges = ({
  odds,
  initialOdds,
  animationLength,
  prefix,
  isSP,
  children,
}: OddsWithChangesProps) => {
  const {
    preferences: { oddsFormat },
  } = usePreferences();

  if (odds === 0) {
    return <span className={styles.odds}>-</span>;
  }

  if (isSP) {
    return <span className={styles.odds}>SP</span>;
  }

  return (
    <BetOddsChange
      odds={odds}
      initialOdds={initialOdds}
      className={styles.odds}
      animationLength={animationLength}
    >
      {children}
      <Odds
        prefix={prefix}
        base={odds || 0}
        format={
          oddsFormat?.toLowerCase() as
            | Lowercase<OddsFormatPreferences>
            | undefined
        }
        zero="1.00"
      />

      <ArrowDown className={styles.arrowDown} />
      <ArrowUp className={styles.arrowUp} />
    </BetOddsChange>
  );
};

export { OddsWithChanges };
